module.exports = "<h1>{{title}}</h1>"